import { Badge, Box, Button, Divider, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CloseIcon from '@mui/icons-material/Close';
import { formatDate2, formatPrice } from '../../../utils/utils';
import PropTypes from 'prop-types';
import { removeFromCart } from '../../../redux/actions/cartactions';
import { CUSTOM_EVENTS } from '../../../utils/constants';

const CartItem = ({name, description, price, itemIndex}) => {
    const handleRemoveItem = () => {
        removeFromCart(itemIndex);
    };

    return (
        <div className='cart-item-container'>
            <div className="cart-item-content space-between">
                <div className="cart-item-data">
                    <Typography variant="h6">{name}</Typography>
                    <Typography>{description}</Typography>
                </div>
                <div className="cart-item-price">
                    <Typography variant="h6">{formatPrice(price)}</Typography>
                </div>
            </div>
            <div className="cart-item-action">
                <Button onClick={handleRemoveItem}>Remove</Button>
            </div>
        </div>
    );
};
CartItem.propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    itemIndex: PropTypes.number.isRequired,
};

const ConfirmOrder = ({closeCart}) => {
    const navigate = useNavigate();
    const {cart} = useSelector(state => state.cart);
    // const CART_ITEMS = [
    //     {
    //         id: 1,
    //         name: 'Fasting Blood Sugar',
    //         description: 'Pre-Test Information: - EMPTY STOMACH',
    //         price: 70
    //     },
    // ];

    const closeDrawer = () => {
        closeCart();
    };

    const handleConfirm = () => {
        navigate('/place-order');
        closeDrawer();
    };

    const cartContent = () => {
        if (cart.length < 1) {
            return <div className='empty-cart-container'>Cart is empty</div>;
        }

        const cartItems = cart.map((cartItem, i) => <CartItem key={cartItem.id} {...cartItem} itemIndex={i} />);
        const cartPrice = cart.reduce((acc, curr) => +curr.price + acc, 0);
        const cartTotals = (
            <div className='cart-totals-container'>
                <div className='flex-gap'>
                    <Typography variant='h6'>Cart Totals:</Typography>
                    <Typography variant="h6">{formatPrice(cartPrice)}</Typography>
                </div>
            </div>
        );

        return (
            <div className='confirm-order-container'>
                <Box className="space-between">
                    <Typography variant="h6">Service Information</Typography>
                    <div>Date: {formatDate2(new Date())}</div>
                </Box>
                <Typography variant="h6">Pathology Lab test</Typography>
                {cartItems}
                <Divider />
                {cartTotals}
            </div>
        );
    };

    const confirmBtn = cart.length > 0 && (
        <div className='cart-step-actions'>
            <Button variant='contained' className='small-brown-btn' onClick={handleConfirm}>Confirm</Button>
        </div>
    );

    return (
        <Box className="cart-drawer-container">
            <div className='space-between'>
                <Typography className='ext-large-brown-txt' style={{textAlign: 'left'}}> My Cart </Typography>
                <CloseIcon onClick={closeDrawer} />
            </div>
            {cartContent()}
            {confirmBtn}
        </Box>
    );
};
ConfirmOrder.propTypes = {
    closeCart: PropTypes.func.isRequired
};

const CartBtn = () => {
    const {cart} = useSelector(state => state.cart);
    const [toggleCart, setToggleCart] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const toggleDrawer = () => {
        setToggleCart(!toggleCart);
    };

    // const showCart = () => navigate('/cart');

    useEffect(() => {
        const openCart = () => { setToggleCart(true); };
        document.addEventListener(CUSTOM_EVENTS.SHOW_CART, openCart);

        return () => {
            document.removeEventListener(CUSTOM_EVENTS.SHOW_CART, openCart);
        };
    }, []);

    const cartDrawer = (
        <>
            <Drawer
                anchor="right"
                open={toggleCart}
                onClose={toggleDrawer}
            >
                <ConfirmOrder closeCart={toggleDrawer} />
            </Drawer>
        </>
    );

    const cartUI = () => {
        if (isMobile) {
            return (
                <Badge badgeContent={cart.length} color="primary">
                    <Typography onClick={toggleDrawer} variant='body1'>Cart</Typography>
                </Badge>
            );
        }

        return (
            <IconButton aria-label="shopping_cart" className='btn-square cart-btn' onClick={toggleDrawer}>
                <Badge badgeContent={cart.length} color="primary">
                    <ShoppingCartIcon />
                </Badge>
            </IconButton>
        );
    };
    return (
        <>
            {cartUI()}
            {cartDrawer}
        </>
    );
};

export default CartBtn;